import React, { useRef } from "react"
import { useQueryParamString } from 'react-use-query-param-string';
import { useEffect, useMemo } from "react"
import "./layout.css"
import Cookies from "universal-cookie"
import { Header } from "../components/header"
import { Footer } from "./footer";
import { ConsentForm } from "./consent_form"

export const Layout = ({
  autoHideHeader,
  children
}) => {
  const [utm_source] = useQueryParamString("utm_source", "")
  const [utm_medium] = useQueryParamString("utm_medium", "")
  const [utm_campaign] = useQueryParamString("utm_campaign", "")
  const [utm_content] = useQueryParamString("utm_content", "")
  const [utm_term] = useQueryParamString("utm_term", "")

  const headerRef = useRef(null);
  const footerRef = useRef(null);

  const cookies = useMemo(() => new Cookies(), []);
  var nextYear = useMemo(() => new Date(), []);
  nextYear.setFullYear(nextYear.getFullYear() + 1)

  useEffect(() => {
    const payload = {}

    if (utm_source !== undefined) payload["utm_source"] = utm_source
    if (utm_medium !== undefined) payload["utm_medium"] = utm_medium
    if (utm_campaign !== undefined) payload["utm_campaign"] = utm_campaign
    if (utm_content !== undefined) payload["utm_content"] = utm_content
    if (utm_term !== undefined) payload["utm_term"] = utm_term

    cookies.set("utm", payload, {
      expires: nextYear,
      path: "/",
      domain: ".cloud66.com"
    })
  }, [nextYear, utm_source, utm_medium, utm_campaign, utm_content, utm_term, cookies])

  useEffect(() => {
    if (!autoHideHeader) return;

    const footer = footerRef.current;
    const header = headerRef.current;

    if (!footer || !header) {
      return;
    }

    // is the footer visible?
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          header.classList.add("opacity-0");
        } else {
          header.classList.remove("opacity-0");
        }
      }
    );

    observer.observe(footer);

    return () => {
      observer.unobserve(footer);
    }

  }, [headerRef, footerRef, autoHideHeader])

  return (
    <div className="h-screen w-full bg-black">
      <div>
        <Header ref={headerRef} autoHide={autoHideHeader} />
        <main className="bg-black min-w-full">
          <>
            {children}
            {process.env.NODE_ENV === "production" ? (
              <ConsentForm />
            ) : null}
          </>
        </main>
        <Footer ref={footerRef} />
      </div>
    </div >
  )
}

